export const NONE = 'NONE';
export const LOWER = 'LOWER';
export const MIDDLE = 'MIDDLE';
export const UPPER = 'UPPER';